import { render, staticRenderFns } from "./ProductVideoItem.vue?vue&type=template&id=2106f812&scoped=true&"
import script from "./ProductVideoItem.vue?vue&type=script&lang=js&"
export * from "./ProductVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductVideoItem.vue?vue&type=style&index=0&id=2106f812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106f812",
  null
  
)

export default component.exports